import "./styles/PageHeader.css";

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  lead?: string;
}

export function PageHeader({ eyebrow, title, lead }: PageHeaderProps) {
  return (
    <header className="page-header container">
      <p className="eyebrow">{eyebrow}</p>
      <h1 className="page-header__title">{title}</h1>
      {lead && <p className="section__lead">{lead}</p>}
    </header>
  );
}
